import { HorizontalContainer, VerticalContainer } from '@/components';
import type { InsurancePartnerBenefit } from '@/features/profile/model/types';

type InsurancePartnerBenefitsCardProps = {
    benefit: InsurancePartnerBenefit;
};

export const InsurancePartnerBenefitsCard = ({
    benefit,
}: InsurancePartnerBenefitsCardProps) => (
    <VerticalContainer
        spacing="lg"
        className="w-full basis-80 rounded-2xl border border-(--color-border-muted) p-6"
    >
        {benefit.iconFilename && (
            <img
                width="40"
                height="40"
                src={`/images/icons/${benefit.iconFilename}`}
                alt=""
            />
        )}

        <h3 className="text-2xl leading-tight font-bold text-(--color-text-heading)">
            {benefit.caregiverName}
        </h3>

        <VerticalContainer spacing="md">
            {benefit.services.map((service, index) => (
                <HorizontalContainer
                    key={`${service.description}-${index}`}
                    spacing="xs"
                    className="items-center"
                >
                    <img
                        width="24"
                        height="24"
                        src={`/images/icons/${service.iconFilename}`}
                        alt=""
                    />
                    <span className="leading-normal">
                        {service.description}
                    </span>
                </HorizontalContainer>
            ))}
        </VerticalContainer>
    </VerticalContainer>
);
